import React, { forwardRef } from 'react';
import { StyledExtension } from './TextField.styles';
export const TextFieldExtension = (props) => React.createElement(StyledExtension, { ...props });
export const TextFieldExtensionButton = forwardRef(function TextFieldExtensionButton(props, ref) {
    return React.createElement(StyledExtension, { ref: ref, as: "button", type: "button", ...props });
});
//# sourceMappingURL=TextFieldExtension.js.map